import { useContext } from 'react';
import { SocketContext } from '../modules/prelude/context/socket';
import Snackbar from '@mui/material/Snackbar';
import Button from '@mui/material/Button';

export const Reconnect: React.FC = () => {
  const ctx = useContext(SocketContext);
  if (ctx.error) {
    return (
      <Snackbar
        open
        message={ctx.connectionMsg}
        action={
          <Button color="inherit" size="small" onClick={() => ctx.reconnect()} disabled={ctx.retrying}>
            Reconnect
          </Button>
        }
        sx={{ bottom: { xs: 90, sm: 0 } }}
      />
    );
  } else {
    return null;
  }
};
